import React, { useState } from 'react';
import ThongKeApi from "service/ThongKe/ThongKeApi";
import { pushNotification } from "utils/notifications";

export const BtnXuatExcel = ({ filters, type }) => {
    const [isLoading, setIsLoading] = useState(false);
    if (!filters) {
        return null;
    }
    const handleExport = async () => {
        if (isLoading) return;
        setIsLoading(true);
        try {
            const response = await ThongKeApi.xuatBaoCaoThuDuKien(type, filters);
            if (response.ok) {
                const contentDisposition = response.headers["content-disposition"];
                let fileName = `BaoCao_${type}.xlsx`;
                if (contentDisposition) {
                    const match = contentDisposition.match(/filename="?(.+)"?/);
                    if (match && match[1]) {
                        fileName = match[1];
                    }
                }
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
                pushNotification("Xuất Excel thành công!", "success");
            } else {
                pushNotification("Xuất Excel thất bại!", "error");
            }
        } catch (error) {
            console.error("Lỗi khi xuất Excel:", error);
            pushNotification("Xuất Excel thất bại!", "error");
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <a
            type="button"
            className="con-bgnew color-print1"
            onClick={handleExport}
            disabled={isLoading}
            style={{
                cursor: isLoading ? 'not-allowed' : 'pointer',
                opacity: isLoading ? 0.5 : 1
            }}
        >
            {isLoading ? (
                <span>Đang xuất...</span>
            ) : (
                <img src="/app-assets/images/icon-tai-xuong-v2.png" title="Xuất Excel" />
            )}
        </a>
    );
};